<template>
  <div id="gli">
    <el-card class="box-card newbb">
      <div slot="header" class="clearfix">
        <span>统计查询&nbsp;/&nbsp;管理员统计</span>
      </div>
      <div>
        <Week @childFn="parentFn"></Week>
        <el-date-picker
          v-model="zctime"
          style="margin: 0 26px 0 0"
          type="daterange"
          value-format="yyyy-MM-dd"
          @blur="time"
          range-separator="至"
          start-placeholder="注册开始日期"
          end-placeholder="注册结束日期"
        >
        </el-date-picker>
        <el-button
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
          >查询</el-button
        >
        <el-button type="info" @click="reset">重置</el-button>
      </div>
    </el-card>
    <el-card class="box-card bdechart">
      <div slot="header" class="clearfix">
        <span>区域：{{ seekCity }}</span>
        <Screendata @choice="timec"></Screendata>
      </div>
      <div class="overview">
        <p>
          <span>市级管理员</span
          ><span
            ><i class="mgr" id="time1">{{ statistics.sheng }}</i
            >人</span
          >
        </p>
        <p>
          <span>区/县级管理员</span
          ><span
            ><i class="mgr" id="time2">{{ statistics.shi }}</i
            >人</span
          >
        </p>
        <p>
          <span>街道/乡镇级管理员</span
          ><span
            ><i class="mgr" id="time3">{{ statistics.qu }}</i
            >人</span
          >
        </p>
        <p>
          <span>社区/村级管理员</span
          ><span
            ><i class="mgr" id="time4">{{ statistics.zhen }}</i
            >人</span
          >
        </p>
      </div>
      <div id="main1" style="width: 100%; height: 370px"></div>
    </el-card>
    <el-card class="box-card bdechart">
      <div slot="header" class="clearfix newbbtit">
        <span>管理员统计明细表</span>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData6"
        id="exportTab"
        :row-class-name="tableRowClassName"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="areaName" width="200" label="区域">
        </el-table-column>
        <el-table-column prop="adminTotalInfo.total1" label="市级数">
        </el-table-column>
        <el-table-column prop="adminTotalInfo.total2" label="区/县级数">
        </el-table-column>
        <el-table-column prop="adminTotalInfo.total3" label="街道/乡镇级数">
        </el-table-column>
        <el-table-column prop="adminTotalInfo.total4" label="社区/村级数">
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ listnum }}</i> 条</span
        >
        <Paging :gopage="listnum" @pag="pag"></Paging>
      </div>
    </el-card>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Screendata from "@/components/Screendata";
import Xlsx from "@/components/Xlsx";
import echarts from "echarts";
import Paging from "@/components/Paging";
export default {
  name: "gli",
  components: {
    Week,
    Screendata,
    Xlsx,
    Paging,
  },
  data() {
    return {
      areaId: "",
      zctime: "",
      userdata: {},
      pageNum: 1,
      pageSize: 10,
      chart: [],
      total: {}, //总计
      tableData6: [],
      stat: "", //定义一个查询
      nowtime: "", //当前是点击查询还是7天等查询
      listnum: 1,
      statistics: { sheng: 0, shi: 0, qu: 0, zhen: 0 },
      formname: JSON.stringify({ name: "管理员统计明细表", hint: "" }),
      fullscreenLoading: true,
      seekCity: "",
    };
  },
  created() {
    this.load();
    this.seekCity = this.userdata.areasName;
  },
  mounted() {},
  methods: {
    tableRowClassName({ row, rowIndex }) {
      // console.log(row.areaName)
      if (row.areaName == "合计") {
        return "re";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.load(2);
    },
    timec(i) {
      this.nowtime = i;
      this.stat = 1;
      this.fullscreenLoading = true;
      this.load(2);
    },
    load(type) {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = {};
      let url = "";
      let newar = "";
      let newtime = "";
      if (this.areaId == "") {
        newar = userdata.areasId;
        url = `/api-r/statistics/getAdminStaticsInitData`;
      } else {
        newar = this.areaId;
        url = `/api-r/statistics/getAdminStaticsData`;
      }
      if (this.nowtime == "") {
        if (this.zctime == "") {
          newtime = "";
        } else {
          newtime = this.zctime.join(",");
        }
      } else {
        newtime = this.nowtime;
      }
      if (this.stat == 1) {
        data = this.$qs.stringify({
          area: newar,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
        });
      } else {
        data = this.$qs.stringify({
          area: userdata.areasId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
        });
        url = `/api-r/statistics/getAdminStaticsInitData`;
      }
      this.$axios
        .post(url, data, { headers: { accessToken: userdata.token } })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            // console.log(res)
            this.$set(this, "chart", res.data.adminStatisticsInfos);

            let arr = res.data.adminStatisticsInfos;
            let obj = {
              areaName: "合计",
              adminTotalInfo: {
                total1: "",
                total2: "",
                total3: "",
                total4: "",
              },
            };
            arr.forEach((x) => {
              obj.adminTotalInfo.total1 =
                Number(obj.adminTotalInfo.total1) +
                Number(x.adminTotalInfo.total1);
              obj.adminTotalInfo.total2 =
                Number(obj.adminTotalInfo.total2) +
                Number(x.adminTotalInfo.total2);
              obj.adminTotalInfo.total3 =
                Number(obj.adminTotalInfo.total3) +
                Number(x.adminTotalInfo.total3);
              obj.adminTotalInfo.total4 =
                Number(obj.adminTotalInfo.total4) +
                Number(x.adminTotalInfo.total4);
            });
            arr.push(obj);

            this.$set(this, "tableData6", arr);
            this.$set(this, "listnum", res.data.totalRecord);
            if (type != 2) {
              this.$Public.NumAutoPlusAnimation("time1", {
                time: 1000, //总时间
                num: res.data.cityNum, //结束数
                regulator: 16, //调速器
                count: 0,
              });
              this.$Public.NumAutoPlusAnimation("time2", {
                time: 1000, //总时间
                num: res.data.countyNum, //结束数
                regulator: 16, //调速器
                count: 0,
              });
              this.$Public.NumAutoPlusAnimation("time3", {
                time: 1000, //总时间
                num: res.data.townNum, //结束数
                regulator: 16, //调速器
                count: 0,
              });
              this.$Public.NumAutoPlusAnimation("time4", {
                time: 1000, //总时间
                num: res.data.villageCommunNum, //结束数
                regulator: 16, //调速器
                count: 0,
              });
              setTimeout(() => {
                this.statistics.sheng = res.data.cityNum;
                this.statistics.shi = res.data.countyNum;
                this.statistics.qu = res.data.townNum;
                this.statistics.zhen = res.data.villageCommunNum;
              }, 2000);
            } else {
              document.getElementById("time1").innerHTML = res.data.cityNum;
              document.getElementById("time2").innerHTML = res.data.countyNum;
              document.getElementById("time3").innerHTML = res.data.townNum;
              document.getElementById("time4").innerHTML =
                res.data.villageCommunNum;
            }
            this.seekCity = res.data.mergerName;
            if (this.stat == 1) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            }
            let myChart1 = echarts.init(
              document.getElementById("main1"),
              "light"
            );
            let option = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                },
              },
              legend: {
                data: ["市级数", "区/县级数", "街道/乡镇级数", "社区/村级数"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              dataZoom: [
                {
                  type: "slider", //数据滑块
                  start: 0,
                  end: 60,
                  height: "10px",
                  minSpan: 8,

                  dataBackground: {
                    lineStyle: {
                      color: "#fff",
                    },
                    areaStyle: {
                      color: "#fff",
                      opacity: 1,
                    },
                  },
                },
                {
                  type: "inside", //使鼠标在图表中时滚轮可用
                },
              ],
              grid: {
                bottom: "75px",
              },
              xAxis: [
                {
                  type: "category",
                  data: [
                    "周一",
                    "周二",
                    "周三",
                    "周四",
                    "周五",
                    "周六",
                    "周日",
                  ],
                },
              ],
              yAxis: [
                {
                  type: "value",
                },
              ],
              series: [
                {
                  name: "市级数",
                  type: "bar",
                  data: [320, 332, 301, 334, 390, 330, 320],
                },
                {
                  name: "区/县级数",
                  type: "bar",
                  data: [120, 132, 101, 134, 90, 230, 210],
                },
                {
                  name: "街道/乡镇级数",
                  type: "bar",
                  data: [220, 182, 191, 234, 290, 330, 310],
                },
                {
                  name: "社区/村级数",
                  type: "bar",
                  data: [150, 232, 201, 154, 190, 330, 410],
                },
              ],
            };
            let arr1 = [];
            let arr2 = [];
            let arr3 = [];
            let arr4 = [];
            let arr5 = [];
            let arr6 = [];
            let arr7 = [];
            this.chart.forEach((x) => {
              arr1.push(x.areaName);
              arr2.push(x.adminTotalInfo.total1);
              arr3.push(x.adminTotalInfo.total2);
              arr4.push(x.adminTotalInfo.total3);
              arr5.push(x.adminTotalInfo.total4);
            });
            option.xAxis[0].data = arr1;
            option.series[0].data = arr2;
            option.series[1].data = arr3;
            option.series[2].data = arr4;
            option.series[3].data = arr5;
            myChart1.setOption(option);
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    parentFn(i) {
      this.areaId = i.id;
      // this.seekCity = i.name
    },
    time() {
      console.log(this.zctime);
    },
    query() {
      this.stat = 1;
      this.nowtime = "";
      this.fullscreenLoading = true;
      this.load(2);
    },
    reset() {
      this.$router.push("/refresh");
    },
  },
};
</script>
<style>
#gli .newbb .el-card__body {
  display: flex;
  align-items: center;
}
#gli .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
#gli .el-table th > .cell {
  font-size: 14px;
  color: #666;
}
/* 暂无数据样式 */
#gli .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
/* #gli .el-pagination{
        margin: 22px 0;
        float: right
    } */
#gli .el-pagination__sizes .el-select {
  margin-top: -12px;
}
#gli .el-table .re {
  color: #11A983;
  font-weight: 800;
}
#gli .el-select > .el-input {
  margin: 0px 0 18px;
}
</style>
<style scoped lang="scss">
.bdechart {
  width: 100% !important;
  margin-top: 24px;
}
.overview {
  display: flex;
  // justify-content: space-around;
  text-align: center;
  border: 1px solid rgb(238, 238, 238);
  margin-bottom: 12px;
  & > p {
    width: 26%;
    border-right: 1px solid rgb(238, 238, 238);
  }
  & > p:nth-of-type(4) {
    width: 26%;
    border-right: none;
  }
  & > p > span {
    display: block;
    width: 100%;
    line-height: 20px;
    line-height: 50px;
    & > i {
      color: #11A983;
      font-size: 36px;
      font-weight: 600;
    }
  }
}
.newbbtit {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mgr {
  margin-right: 3px;
}
</style>
